import DataCollectionAdd from '../../shared/DataCollectionAdd.js';
import { useTranslation } from 'react-i18next';

const toDbKey = (name) =>
  name.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');

const AddLotFieldForm = () => {
  const { t } = useTranslation();
  return (
    <>
      <input type="text" name="friendly_name" placeholder={t('lot_field_friendly_name')} required />
      <input type="text" name="aliases"        placeholder={t('lot_field_aliases_hint')} />
    </>
  );
};

const getBodyFromForm = (formData) => {
  const friendlyName = formData.get('friendly_name') || '';
  const aliasesRaw   = formData.get('aliases') || '';
  const dbKey        = toDbKey(friendlyName);
  const aliases      = aliasesRaw.split(';').map(s => s.trim()).filter(Boolean);
  return JSON.stringify({ friendly_name: friendlyName, db_key: dbKey, aliases });
};

export const AddLotField = ({ onSuccess }) => (
  <DataCollectionAdd
    collection="lots.custom_fields"
    getBodyFromForm={getBodyFromForm}
    formElements={AddLotFieldForm}
    onSuccess={onSuccess}
  />
);

export default AddLotField;
